exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1m9k{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_1m9k",
	"root": "_1m9k"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/InfolettreSidebar/InfolettreSidebar.css
// module id = 231
// module chunks = 0